let bsParams = {
  id: '',     // id
  publishMaterialId: '',     // publishMaterialId
  publishId: '',     // 出版单位ID

  qualificationTs: '0',     // 出版资质-图书  1-是  0-否
  qualificationQk: '0',     // 出版资质-期刊  1-是  0-否
  qualificationYx: '0',     // 出版资质-音像  1-是  0-否
  qualificationDz: '0',     // 出版资质-电子  1-是  0-否
  qualificationWl: '0',     // 出版资质-网络  1-是  0-否
  qualificationBz: '0',     // 出版资质-报纸  1-是  0-否
  qualificationRm1: '0',     // 出版资质-备用1  1-是  0-否
  qualificationRm2: '0',     // 出版资质-备用2  1-是  0-否


  mainBusinessTs: '0',     // 主营业务-音像  1-是  0-否
  mainBusinessQk: '0',     // 主营业务-电子  1-是  0-否
  mainBusinessWl: '0',     // 主营业务-网络  1-是  0-否
  mainBusinessBz: '0',     // 主营业务-报纸  1-是  0-否
  mainBusinessRm1: '0',     // 主营业务-备用1  1-是  0-否
  mainBusinessRm2: '0',     // 主营业务-备用2  1-是  0-否

  otherbusiness: '', // 营收高于出版业务的其他主营业务


  expandBusinessEmpty: '0',     // 拓展业务-无  1-是  0-否
  expandBusinessMedium: '0',     // 拓展业务-媒体  1-是  0-否
  expandBusinessWeb: '0',     // 拓展业务-网络  1-是  0-否
  expandBusinessBook: '0',     // 拓展业务-图书  1-是  0-否
  expandBusinessLxdz: '0',     // 拓展业务-连续电子  1-是  0-否
  expandBusinessOther: '0',     // 拓展业务-其他  1-是  0-否
  expandBusinessOtherFill: '',     // 拓展业务-其他填写  1-是  0-否
  expandBusinessRm1: '0',     // 拓展业务-备用1  1-是  0-否
  expandBusinessRm2: '0',     // 拓展业务-备用2  1-是  0-否


  operationProjectEmpty: '0',     // 开设并运营-无  1-是  0-否
  operationProjectWeb: '0',     // 开设并运营-媒体  1-是  0-否
  operationProjectWebNum: 0,     // 开设并运营-网络  1-是  0-否
  operationProjectDatabase: '0',     // 开设并运营-图书  1-是  0-否
  operationProjectDatabaseNum: 0,     // 开设并运营-连续电子  1-是  0-否
  operationProjectWechat: '0',     // 开设并运营-其他  1-是  0-否
  operationProjectWechatNum1: 0,     // 开设并运营-其他填写  1-是  0-否
  operationProjectWechatNum2: 0,     // 开设并运营-备用1  1-是  0-否
  operationProjectApp: '0',     // 开设并运营-备用2  1-是  0-否
  operationProjectAppNum: 0,     // 开设并运营-无  1-是  0-否
  operationProjectWeibo: '0',     // 开设并运营-媒体  1-是  0-否
  operationProjectWeiboNum: 0,     // 开设并运营-网络  1-是  0-否
  operationProjectOther: '0',     // 开设并运营-图书  1-是  0-否
  operationProjectOtherNum: 0,     // 开设并运营-连续电子  1-是  0-否
  operationProjectOtherFill: '0',     // 开设并运营-其他  1-是  0-否
  operationProjectRm1: '',     // 开设并运营-备用1 1-是 0-否
  operationProjectRm2: '',     // 开设并运营-备用2  1-是  0-否

  pepnumProcess: 0,     // 除编辑以外有关制作加工等
  pepnumInternation: 0,     // 除编辑以外的有关新媒体、网络运营等技术人员
  pepnumIssue: 0,     // 专职发行人员
  pepnumOther: 0,     // 其他人员，包括行政人员等
  pepnumTotal: 0,     // 总人数（应该是计算出来的，因为编辑人员、领导是动态的）

  remark: '',     // 备注
  createdAt: '',     // 创建时间
  updatedAt: '',     // 更新时间

}

let paramsRule = {

    // year: [
    //     { required: true, message: '请选择', trigger: 'change' },
    // ],     // 年度
    // publicationName: [
    //     { required: true, message: '不能为空！', trigger: 'blur' },
    //     { max: 127, message: '填写内容过长！', trigger: 'blur' }
    // ],     // 出版物名称
    // isbn: [
    //     { required: true, message: '不能为空！', trigger: 'blur' },
    //     { max: 127, message: '填写内容过长！', trigger: 'blur' }
    // ],     // 专用书号 ISBN
    // carrierForm: [
    //     { required: true, message: '请选择', trigger: 'change' },
    // ],     // 载体形式（选择项）
    // publicationForm: [
    //     { required: true, message: '请选择', trigger: 'change' },
    // ],     // 出版形式（选择项）
    // carrierFormQT: [
    //     { required: true, message: '不能为空！', trigger: 'blur' },
    //     { max: 127, message: '填写内容过长！', trigger: 'blur' }
    // ],     // 专
    // productionUnit: [
    //     { required: true, message: '不能为空！', trigger: 'blur' },
    //     { max: 127, message: '填写内容过长！', trigger: 'blur' }
    // ],     // 节目来源/制作单位
    // programCapacity: [
    //     { required: true, message: '请选择', trigger: 'change' },
    // ],     // 节目时长或容量(分钟/兆)
    // publicationQuantity: [
    //     { required: true, message: '请选择', trigger: 'change' },
    // ],     // 出版数量（张/盒）
    // issueQuantity: [
    //     { required: true, message: '请选择', trigger: 'change' },
    // ],     // 发行数量（张/盒）
    // unitPrice: [
    //     { required: true, message: '请选择', trigger: 'change' },
    // ],     // 发行单价（元）
    // publishingTime: [
    //     { required: true, message: '请选择', trigger: 'change' },
    // ],     // 出版时间
    // sampleDelivery: [
    //     { required: true, message: '请选择', trigger: 'change' },
    // ],     // 样品缴送（选择项）
    // sign: [
    //     { required: true, message: '请选择', trigger: 'change' },
    // ],     // 书配盘标记（选择项）

}

export { bsParams, paramsRule }



// WEBPACK FOOTER //
// ./src/components/LongParams/paramsEt209.js